import { ReportChart } from '@/components/relatorios/ReportChart'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv, formatCurrency, formatPercent } from '@/components/relatorios/reportUtils'
import { useCampaignSalesReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'

export default function VendasCampanhaReport() {
  const [range, setRange] = useReportDateRange()
  const report = useCampaignSalesReport(range)
  const leads = report.data.reduce((sum, row) => sum + row.leads, 0)
  const sales = report.data.reduce((sum, row) => sum + row.sales, 0)
  const revenue = report.data.reduce((sum, row) => sum + row.revenue, 0)

  return (
    <ReportShell
      title="Vendas por anúncio/campanha"
      description="Coorte de leads do período atribuída à campanha do primeiro toque."
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={leads === 0}
      onRetry={report.refetch}
      onExport={() => exportCsv('vendas-campanha', report.data, [
        { label: 'Campanha', value: (row) => row.campaign },
        { label: 'Leads', value: (row) => row.leads },
        { label: 'Vendas', value: (row) => row.sales },
        { label: 'Receita', value: (row) => row.revenue.toFixed(2).replace('.', ',') },
        { label: 'Conversão (%)', value: (row) => row.conversion.toFixed(1).replace('.', ',') },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label="Leads da coorte" value={leads} />
        <ReportKpiCard label="Vendas" value={sales} />
        <ReportKpiCard label="Receita" value={formatCurrency(revenue)} />
        <ReportKpiCard label="Conversão" value={formatPercent(leads ? (sales / leads) * 100 : 0)} />
      </div>
      <ReportChart
        type="bar"
        data={report.data.map((row) => ({ ...row }))}
        xKey="campaign"
        series={[
          { key: 'leads', label: 'Leads', color: 'var(--chart-1)' },
          { key: 'sales', label: 'Vendas', color: 'var(--chart-2)' },
        ]}
      />
      <ReportTable
        rows={report.data}
        rowKey={(row) => row.campaignId}
        columns={[
          { key: 'campaign', label: 'Campanha', render: (row) => row.campaign },
          { key: 'leads', label: 'Leads', align: 'right', render: (row) => row.leads },
          { key: 'sales', label: 'Vendas', align: 'right', render: (row) => row.sales },
          { key: 'revenue', label: 'Receita', align: 'right', render: (row) => formatCurrency(row.revenue) },
          { key: 'conversion', label: 'Conversão', align: 'right', render: (row) => formatPercent(row.conversion) },
        ]}
      />
    </ReportShell>
  )
}
